import api from './axios';

// Auth API (Login only - no registration)
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  getMe: () => api.get('/auth/me')
};

export default authAPI;
